import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'PAYMENT_UPDATE',
    smsDelete : 'PAYMENT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        payment_log: [],
        payment_log_count: null,
        payment_detail: {},

        submitSuccess: false,
        paymentLoading: false,
        paymentError: false,
        paymentDetailLoading: false,
        paymentDetailError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_PAYMENT(state, {results, pg_count}) {
            state.payment_log = results;
            state.payment_log_count = pg_count;
        },

        SET_PAYMENT_DETAILS(state, payment) {
            state.payment_detail = payment;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        PAYMENT_LOADING (state, loading) {
            state.paymentLoading = loading;
        },

        PAYMENT_ERROR (state, hasError) {
            state.paymentError = hasError;
        },

        PAYMENT_DETAILS_LOADING (state, loading) {
            state.paymentDetailLoading = loading;
        },

        PAYMENT_DETAILS_ERROR (state, hasError) {
            state.paymentDetailError = hasError;
        }
    },

    actions: {
        async addPaymentLog ({commit, dispatch}, payload) {
            commit('PAYMENT_LOADING', true);
            commit('PAYMENT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                },
            };

            try {
                let response = await axios.post(V1API.create_payment, payload.payment, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPaymentLog')
                return response

            } catch (e) {
                commit('PAYMENT_ERROR', true);
            } finally {
                commit('PAYMENT_LOADING', false);
            }
        },

        async fetchPaymentLog ({ commit }, payload) {
            commit('PAYMENT_LOADING', true);
            commit('PAYMENT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);

                let url = V1API.payment_log_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, pg_count} = result.data
                commit('SET_PAYMENT', {results, pg_count});
                return result
            } catch(error) {
                commit('PAYMENT_ERROR', true);
            } finally {
                commit('PAYMENT_LOADING', false);
            }
        },

        async fetchPaymentDetails ({ commit }, payload) {
            commit('PAYMENT_DETAILS_LOADING', true);
            commit('PAYMENT_DETAILS_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.payment_details + payload, config);
                let response = result.data
                commit('SET_PAYMENT_DETAILS', response.data);
                return response

            } catch(error) {
                commit('PAYMENT_DETAILS_ERROR', true);
            } finally {
                commit('PAYMENT_DETAILS_LOADING', false);
            }
        },

        async updatePaymentLog ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_payment + payload.id, payload.payment, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPaymentLog')
                return response

            } catch (e) {
                commit('PAYMENT_ERROR', true);
            } finally {
                commit('PAYMENT_LOADING', false);
            }
        },

        async deletePaymentLog({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.payment_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPaymentLog')
            return response
        }
    },

    getters: {}
}
